module.exports = __webpack_public_path__ + "static/img/title7.af7bb5ad.png";